module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page label-manage-page mx-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.currentUser.user_type == 'artist') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("My Labels")]), _vm._v(" "), _c('ul', _vm._l((_vm.artist_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.navigatorState.tab == 'approved_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.approved_labels || _vm.approved_labels.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no approved labels")])])] : [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.approved_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.host,
        "deleteFunc": _vm.showLabelDeleteConfirmDialog,
        "deleteButtonText": 'remove label'
      }
    })]
  })], 2)]], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'approved_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.approved_albums || _vm.approved_albums.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no approved albums")])])] : [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.approved_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "deleteButtonFunc": _vm.showAlbumDeleteConfirmDialog,
        "deleteButtonText": "Remove <br>from Record Label",
        "deleteButtonClass": "height text-xs-left"
      }
    })], 1)
  }))]], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.pending_labels || _vm.pending_labels.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no pending labels")])])] : [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.pending_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.host,
        "acceptFunc": _vm.acceptLabelUserRequest,
        "denyFunc": _vm.denyLabelUserRequest
      }
    })]
  })], 2)]], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.pending_albums || _vm.pending_albums.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no pending albums")])])] : [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.pending_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "showPromoteButton": false,
        "acceptButtonFunc": _vm.acceptLabelAlbumRequest,
        "denyButtonFunc": _vm.denyLabelAlbumRequest
      }
    })], 1)
  }))]], 2)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentUser.user_type == 'label') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Record Label")]), _vm._v(" "), _c('ul', _vm._l((_vm.label_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.navigatorState.tab == 'approved_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "add-product-btn",
    nativeOn: {
      "click": function($event) {
        _vm.showSelectUserDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add Artist\n              ")], 1)], 1), _vm._v(" "), _vm._l((_vm.approved_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.client,
        "deleteFunc": _vm.showRosterDeleteConfirmDialog,
        "deleteButtonText": 'remove artist from roster'
      }
    })]
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'approved_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.approved_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "deleteButtonFunc": _vm.showAlbumDeleteConfirmDialog,
        "deleteButtonText": "Remove <br>from Record Label",
        "deleteButtonClass": "height text-xs-left"
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.not_approved_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.client,
        "status": relation.status,
        "deleteFunc": _vm.showLabelDeleteConfirmDialog
      }
    })]
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.not_approved_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "showPromoteButton": false,
        "deleteButtonFunc": _vm.showAlbumDeleteConfirmDialog,
        "deleteButtonText": "Remove <br>from Record Label",
        "deleteButtonClass": 'height text-xs-left',
        "status": _vm._f("capitalize")(user_album.status)
      }
    })], 1)
  }))], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_select_user_modal) ? _c('select-user-modal', {
    attrs: {
      "title": "Add Artist to Roster",
      "type": "artist",
      "dismiss": _vm.hideSelectUserDialog,
      "selectUser": _vm.sendRequestToAdd
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.label_delete_confirm_dialog),
      callback: function($$v) {
        _vm.label_delete_confirm_dialog = $$v
      },
      expression: "label_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Label")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, you won't see this label any more. Click OK to\n        delete <" + _vm._s(_vm.user.username) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeLabel()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideLabelDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.roster_delete_confirm_dialog),
      callback: function($$v) {
        _vm.roster_delete_confirm_dialog = $$v
      },
      expression: "roster_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Roster")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, you won't add roster's album to your label any more.\n        Click OK to delete <" + _vm._s(_vm.user.username) + ">, or click\n        Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeRoster()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideRosterDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.album_delete_confirm_dialog = $$v
      },
      expression: "album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Remove an Album from your Record Label")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, your followers won't see the album any more. Click\n        OK to remove <" + _vm._s(_vm.album.name) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideAlbumDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.album_status_confirm_dialog),
      callback: function($$v) {
        _vm.album_status_confirm_dialog = $$v
      },
      expression: "album_status_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.status_dialog_title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.status_dialog_text))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateAlbumStatus()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideAlbumStatusConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('label', [_vm._v("Labels")])]), _vm._v(" "), _c('v-card-text', [_c('div', [_c('h4', [_vm._v("Labels")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Invite artists")]), _vm._v(" to your roster.")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Request albums")]), _vm._v(" to be added to your catalog.")])]), _vm._v(" "), _c('h4', [_vm._v("Artists")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Manage")]), _vm._v(" your approved labels & albums.")])])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189a18ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/label/manage.vue
// module id = 1628
// module chunks = 180